export enum RouteNamesEnum {
    Login = 'login',
    Home = 'devices',
    ResetPassword = 'reset-password',
    Users = 'users',
    MyAccount = 'my-account',
    Units = 'units',
    Locations = 'locations',
    Types = 'types',
    Names = 'names',
    Producers = 'producers',
    ProbeReads = 'probe-reads',
    ProbeTypes = 'probe-types',
    Calibrations = 'calibrations',
    Orders = 'orders',
}
